<script setup lang="ts">
  import { ref } from 'vue';
  import { IconImage } from '@/shared/ui';
  import SmallChevronUpIcon from '@/shared/assets/icons/SmallChevronUp.svg';

  interface Props {
    title: string;
    defaultExpanded?: boolean;
  }

  withDefaults(defineProps<Props>(), {
    defaultExpanded: true,
  });

  const isExpanded = ref(true);

  const toggleExpanded = () => {
    isExpanded.value = !isExpanded.value;
  };
</script>

<template>
  <div class="border-b border-border-color">
    <button
      type="button"
      class="w-full flex items-center justify-between py-4 text-left hover:bg-gray-50 transition-colors"
      @click="toggleExpanded"
    >
      <h2 class="text-gray-07 text-sm font-semibold">
        {{ title }}
      </h2>
      <IconImage
        :src="SmallChevronUpIcon"
        alt="Toggle"
        class="transition-transform duration-200 text-slate-950"
        :class="{ 'rotate-180': !isExpanded }"
      />
    </button>
    <div
      v-if="isExpanded"
      class="pb-4"
    >
      <slot />
    </div>
  </div>
</template>
